var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":_vm.label}},[_c('b-form-input',{attrs:{"placeholder":_vm.placeholder || `Enter ${_vm.label}`,"type":_vm.type,"value":_vm.value},on:{"input":_vm.onInput}}),(_vm.error)?_c('span',{staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.error)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }